import { Component, OnInit } from '@angular/core';
import { PageContainerService } from '../../../services';

@Component({
  standalone: false,
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  releaseId: string = '';

  releaseUrl: string;
  constructor(private pcs: PageContainerService) { }

  async ngOnInit() {
    let baseReleaseUrl: string = 'TEMPurl';
    let response = await this.pcs.apiService.GetReleaseNumber({}, false, false);
    if (response.ReleaseId != undefined && response.ReleaseId != null) {
      this.releaseId = response.ReleaseId;
      let releaseIdLastPeriodIndex: number = this.releaseId.lastIndexOf('.');
      this.releaseUrl = (releaseIdLastPeriodIndex !== -1) ? baseReleaseUrl + this.releaseId.substr(releaseIdLastPeriodIndex + 1) : null;
    }
  }
}
